import { render, staticRenderFns } from "./DuplicatedRequestInfo.vue?vue&type=template&id=c6bf0d1a&scoped=true&"
import script from "./DuplicatedRequestInfo.vue?vue&type=script&lang=js&"
export * from "./DuplicatedRequestInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bf0d1a",
  null
  
)

export default component.exports